import { useTranslation } from 'react-i18next';
import { useInfluencerPackagePermissions } from '@anytag/auth';
import { TableV2 } from '@anytag/shared-atoms';
import { useCampaignInfluencersContext } from '../CampaignInfluencersContext';
import { useCampaignInfluencersTable } from '../hooks';

export const CampaignInfluencersList = () => {
  const { t } = useTranslation();
  const { hideAddPackageBtn } = useInfluencerPackagePermissions();
  const { loading, campaignId, listRecords } = useCampaignInfluencersContext();
  const { columns } = useCampaignInfluencersTable({ campaignId });

  return (
    <TableV2
      loading={loading}
      data={listRecords}
      columns={columns}
      empty={{ linkProps: !hideAddPackageBtn ? { to: '/package/add', label: t('Add package') } : undefined }}
      noTopBorderRadius
      hasBorder
    />
  );
};
